import { FC, isValidElement } from 'react';
import { PrivacyRightsLoadingSkeletonProps } from './PrivacyRightsWrapper.types';

export const PrivacyRightsLoadingSkeleton: FC<PrivacyRightsLoadingSkeletonProps> = ({
  className,
  isLoading,
  children,
}) => (isLoading ? <div className={`skeleton-loader ${className}`} /> : isValidElement(children) ? children : null);
